import { mutatorAction } from 'satcheljs';
import { getGroupFolder } from '../selectors/getGroupFolder';

export default mutatorAction(
    'removeGroupFolderFromParentFolder',
    (groupId: string, folderId: string) => {
        let folderToRemove = getGroupFolder(groupId, folderId);
        let parentFolder = getGroupFolder(groupId, folderToRemove?.ParentFolderId ?? '');

        if (folderToRemove && parentFolder) {
            // Remove folder from the childfolder ids of parent folder
            let childFolderIds = parentFolder.ChildFolderIds;
            const folderIdIndex = childFolderIds?.indexOf(folderId) ?? -1;

            if (folderIdIndex !== -1) {
                childFolderIds.splice(folderIdIndex, 1);
                parentFolder.ChildFolderCount--;
            }

            // Set the parentfolder id of the removed folder to be empty
            folderToRemove.ParentFolderId = '';
        }
    }
);
